import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import defaultState from './defaultState'

Vue.use(Vuex)

const vuexPersist = new VuexPersistence<any>({
  storage: localStorage
})

const defaultStateFactory = () => {
  return {
    user: null,
    additionaluserinfo: null,
    userprofile: null
  }
}

export default new Vuex.Store({
  state: {
    user: null,
    additionaluserinfo: null,
    userprofile: null,
    blog: []
  },
  getters: {
    userinformation: state => {
      return { ...state.additionaluserinfo, ...state.user, ...state.userprofile }
    },
    
    // Footer section
    github_link: state => {
      return 'https://github.com/afletcher53'
    },
    linkedin_link: state => {
      return 'https://www.linkedin.com/in/aaron-fletcher-bvetmed-mrcvs/'
    },
    twitter_link: state => {
      return 'https://twitter.com/afletcher53'
    },
    email: state => {
      return 'afletcher53@gmail.com'
    },
    feature_vuejs: state => {
      return 'https://vuejs.org/'
    },
    feature_firebase: state => {
      return 'https://firebase.google.com//'
    },
    blog: state => {

      return state.blog
    }
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setBlog (state, blog) {
      console.log('Blog has been set')
      state.blog.push(blog)
    },
    clearStore(state){
      Object.assign(state, defaultState())
    },
    setAdditionalUserInfo (state, additionaluserinfo) {
      console.log('Additional User information has been set')
      state.additionaluserinfo = additionaluserinfo
    },
    setUserProfile (state, userprofile) {
      state.userprofile = userprofile
    },
    resetUserState (state) {
      Object.assign(state, defaultStateFactory())
    },
    updateUserProfile (state, payload) {
      state.userprofile.about = payload.about
      state.userprofile.displayName = payload.displayName
      state.userprofile.notification_level_blogs = payload.notification_level_blogs
      state.userprofile.notification_level_site = payload.notification_level_site
    }
  },
  actions: {
    setUser ({ commit }, user) {
      commit('setUser', user)
    },
    setAdditionalUserInfo ({ commit }, additionaluserinfo) {
      commit('setAdditionalUserInfo', additionaluserinfo)
    },
    setUserProfile ({ commit }, userProfile) {
      commit('setUserProfile', userProfile)
    },
    updateUserProfile ({ commit }, payload) {
      commit('updateUserProfile', payload)
    },
    setBlog({ commit }, blog) {
      commit('setBlog', blog)
    }
  },
  modules: {
  },
  plugins: [vuexPersist.plugin]
})
